/**
 * Quiz Question Signal Constants
 *
 * Constants for the quiz question signal/report feature.
 * Used to standardize signal types across the app.
 */

export const QUIZ_SIGNAL_TYPES = {
    INCORRECT_QUESTION: 'incorrect_question',
    INCORRECT_ANSWER: 'incorrect_answer',
    DISPLAY_ISSUE: 'display_issue',
    TOO_DIFFICULT: 'too_difficult',
}

export const QUIZ_SIGNAL_LABELS = {
    [QUIZ_SIGNAL_TYPES.INCORRECT_QUESTION]: 'Question incorrecte ou pas claire',
    [QUIZ_SIGNAL_TYPES.INCORRECT_ANSWER]: 'Réponse(s) incorrecte(s)',
    [QUIZ_SIGNAL_TYPES.DISPLAY_ISSUE]: "Problème d'affichage",
    [QUIZ_SIGNAL_TYPES.TOO_DIFFICULT]: 'Trop difficile ou pas adapté au niveau',
}

export const QUIZ_SIGNAL_ICONS = {
    [QUIZ_SIGNAL_TYPES.INCORRECT_QUESTION]: 'question-circle',
    [QUIZ_SIGNAL_TYPES.INCORRECT_ANSWER]: 'times-circle',
    [QUIZ_SIGNAL_TYPES.DISPLAY_ISSUE]: 'desktop',
    [QUIZ_SIGNAL_TYPES.TOO_DIFFICULT]: 'exclamation-triangle',
}

export const QUIZ_SIGNAL_CONTEXTS = {
    DURING_QUIZ: 'during_quiz',
    REVIEW: 'review',
}
